import { CANDIDATE_REJECTION_REASONS_ARRAY } from 'constants/candidateConstants';

export const getRejectionReasonText = (rejectionReason) =>
    CANDIDATE_REJECTION_REASONS_ARRAY.find(x => x.key === rejectionReason).value;
